<template>
  <v-container>
      <v-row>
          <v-col>
              <v-row justify="center" class="mt-10 mb-10">
                  <strong class="primary--text">Sign In</strong>
              </v-row>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <v-row justify="center">
                  <v-form>
                    <v-text-field
                        label="Email Address"
                        outlined
                        dense                      
                        full-width
                        class="text-field"
                        color="primary"
                        v-model="email"
                    ></v-text-field> 
                    <v-text-field
                        label="Password"
                        outlined
                        dense
                        full-width
                        class="text-field mt-5"
                        color="primary"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                         :type="showPassword ? 'text' : 'password'"
                         @click:append="showPassword = !showPassword"
                         v-model="password"
                    ></v-text-field>
                    <v-btn class="primary mt-5 text-field" @click="signIn">Sign in</v-btn>       
                  </v-form>
              </v-row>
          </v-col>
      </v-row>
        <v-row>
            <v-col>
                <v-row justify="center">
                    <div class="sign-up mt-10">
                        <p>New to CareSoft ? 
                            <router-link to ="/registration" class="primary--text">Sign Up</router-link>
                        </p>
                    </div>
                </v-row>
            </v-col>
        </v-row>
  </v-container>
</template>

<script>
import {mapActions}  from "vuex"
export default {
    name: "Login",
    data() {
        return {
            showPassword: false,
            email:          "",
            password:       "",
        }
    }, 
    methods: {
        ...mapActions(['login']),
        signIn() {
            let user = {
                email: this.email,
                password: this.password
            }
            this.login(user).then(result => {
                console.log(result)
                if(result.data.success) {
                    this.$router.push('/Dashboard')
                }
            })
        }
    }

}
</script>

<style>
    .text-field {
        width: 420px;
        text-align: center;
        border-radius: 8px;
        
    }
    .sign-up {
        text-align: left;
        width: 460;
                
    }

</style>